// Table geometry the physics uses, without three.js: the pocket polygons (a ball whose centre enters one is
// potted, physics/solver.ts) and the cushion line (the walls, shared/rules.ts CUSHION_LINE). physics/table.ts builds the
// physics from these and TableModel.ts the 3D table, so what you see lines up with what the balls do.
//
// Coordinates: the physics plane (x across the table, y along it = three.js z).
export interface Pt { x: number; y: number }
export interface Pocket { vertices: Pt[] }

export {CUSHION_LINE} from "./shared/rules";

// Order: top-left corner, left middle, bottom-left corner, bottom-right corner, right middle, top-right corner
// ("left" = -x, "top" = +y, the black's end).
export const POCKETS: Pocket[] = [{vertices: [{x:-4.29287, y:7.52713},
            {x:-4.35639, y:6.84398},
            {x:-4.45601, y:6.51752},
            {x:-4.60578, y:6.27286},
            {x:-4.87837, y:6.10862},
            {x:-5.27944, y:5.93679},
            {x:-5.75885, y:5.91043},
            {x:-5.85708, y:5.90503},
            {x:-5.85708, y:7.52713}]},
        {vertices: [{x:-5.27318, y:0.59766},
                {x:-5.07642, y:0.54268},
                {x:-4.95244, y:0.45159},
                {x:-4.8448, y:0.25944},
                {x:-4.79746, y:0.02226},
                {x:-4.8448, y:-0.21492},
                {x:-4.95244, y:-0.40708},
                {x:-5.07642, y:-0.49816},
                {x:-5.27318, y:-0.55315},
                {x:-5.85709, y:-0.3588},
                {x:-5.85709, y:0.40332}]},
        {vertices: [{x:-5.85708, y:-5.86052},
                {x:-5.75885, y:-5.86592},
                {x:-5.27944, y:-5.89227},
                {x:-4.87837, y:-6.06411},
                {x:-4.60578, y:-6.22834},
                {x:-4.45601, y:-6.473000},
                {x:-4.35639, y:-6.79947},
                {x:-4.29287, y:-7.48262},
                {x:-5.85708, y:-7.48262}]},
        {vertices: [{x:2.42081, y:-7.48262},
                {x:2.48432, y:-6.79947},
                {x:2.58395, y:-6.47300},
                {x:2.73372, y:-6.22834},
                {x:3.006300, y:-6.06411},
                {x:3.40737, y:-5.89227},
                {x:3.88678, y:-5.86592},
                {x:3.98502, y:-5.86052},
                {x:3.98502, y:-7.48262}]},
        {vertices: [{x:3.40112, y:-0.55315},
                {x:3.20435, y:-0.49816},
                {x:3.08038, y:-0.40708},
                {x:2.97273, y:-0.21492},
                {x:2.925400, y:0.02226},
                {x:2.97273, y:0.25944},
                {x:3.08038, y:0.45159},
                {x:3.20435, y:0.54268},
                {x:3.40112, y:0.59766},
                {x:3.98502, y:0.40332},
                {x:3.98502, y:-0.3588}]},
        {vertices: [{x:3.98502, y:5.90503},
                {x:3.88679, y:5.91043},
                {x:3.40737, y:5.93679},
                {x:3.006300, y:6.10862},
                {x:2.73372, y:6.27286},
                {x:2.58395, y:6.51752},
                {x:2.48432, y:6.84398},
                {x:2.42081, y:7.52714},
                {x:3.98502, y:7.52713}]}];
